import Vue from "vue";
import App from "./App.vue";

/*
===========================
>>> Globally register all components from 'src/components/global' directory
===========================
*/
const modules = import.meta.glob("@/components/global/**/*.vue", { eager: true });
for (const path in modules) {
  const comp = modules[path].default;
  const name = comp.name ?? path.split("/").pop().replace(/\.vue$/i, "");
  Vue.component(name, comp);
}
/*
===========================
*/

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();

new Vue({
  render: (h) => h(App),
}).$mount("#app");
